// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setup-heading[data-v-867d6dfc] {
  text-align: center;
}
.email-input[data-v-867d6dfc] .icon-right svg {
  fill: #5b5a63;
  color: #5b5a63;
}
.email-input[data-v-867d6dfc] .icon-right .i-icon:hover {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/Web/scripts/components/join-publication/JoinPublicationSignUp.vue","webpack://./JoinPublicationSignUp.vue"],"names":[],"mappings":"AAEA;EACE,kBAAA;ACDF;ADIA;EACE,aAAA;EACA,cAAA;ACDF;ADIA;EACE,UAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.setup-heading {\n  text-align: center;\n}\n\n.email-input :deep(.icon-right svg) {\n  fill: #5b5a63;\n  color: #5b5a63;\n}\n\n.email-input :deep(.icon-right .i-icon:hover) {\n  opacity: 1;\n}\n",".setup-heading {\n  text-align: center;\n}\n\n.email-input :deep(.icon-right svg) {\n  fill: #5b5a63;\n  color: #5b5a63;\n}\n\n.email-input :deep(.icon-right .i-icon:hover) {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
